import React from 'react';

import { Breadcrumbs } from 'components/util/BreadCrumb';
import Header from 'components/util/cabecario/.mixins';

import { useHelmet } from 'hooks';
import type { IRouterProps } from 'pages/orderHistory';

export const TopBar = ({ router }: IRouterProps) => {
  useHelmet({ title: ` ${process.env.REACT_APP_TITLE} - Histórico de agendamento` });

  function goBack() {
    router.push('/');
  }

  return (
    <>
      <Header title="Histórico de agendamento" goBack={goBack} />

      <Breadcrumbs
        breadcrumbs={[
          {
            label: 'Histórico de agendamento',
            href: '#'
          }
        ]}
      />
    </>
  );
};
